<template>
  <model-crud
    :model="model"
    :editable="false"
    :deletable="false"
    :bulk="false"
    :paginating="!small"
    :exportable="!small"
    :filtering="!small"
    :fields="fields"
  >
    <template slot="text" slot-scope="row">
      {{ $t(textValues[row.item.type], JSON.parse(row.item.text)) }}
    </template>
  </model-crud>
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import CompanyNotification from '@/models/CompanyNotification'
import Company from '@/models/Company'

export default {
  props: {
    small: Boolean
  },
  data () {
    return {
      textValues: {
        AUTOMATIC_TARGET: 'companyNotifications.automaticTarget',
        QUOTA_USAGE: 'companyNotifications.quotaUsage'
      },
      model: CompanyNotification,
      fields: {
        date: {
          label: this.$t('headers.date'),
          type: 'date'
        },
        company: {
          label: this.$t('headers.company'),
          roles: ['SUPER_ADMIN', 'COMPANY_ADMIN'],
          type: 'reference',
          model: Company
        },
        severity: {
          label: this.$t('headers.severity'),
          type: 'enum',
          values: CompanyNotification.enums.severity
        },
        type: {
          label: this.$t('headers.type'),
          type: 'enum',
          values: CompanyNotification.enums.type
        },
        text: {
          label: this.$t('headers.text')
        }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Notifications.vue?428d26f6